export const DEFAULT_PROMOTION_SUBJECT = "Fresh puzzles just added on Jigsaw Muse";
export const DEFAULT_WEB_PROMOTION_SUBJECT =
    "Word Wheel Quest on Puzzle Interact — Daily and Journey";
export const DEFAULT_WORD_WHEEL_PROMOTION_SUBJECT = "Today’s word on Word Wheel Quest";
export const DEFAULT_SLIDING_PROMOTION_SUBJECT = "Fresh puzzles just added on Sliding Puzzle Quest";
export const GREETING_PLACEHOLDER = "Hi {{firstName}},";
export const GREETING_FALLBACK = "Puzzle Lover";

/** First token of a display name, or Puzzle Lover when missing / email-like. */
export function firstNameOrFallback(name) {
    if (name == null || !String(name).trim()) {
        return GREETING_FALLBACK;
    }
    const trimmed = String(name).trim();
    if (trimmed.includes("@")) {
        return GREETING_FALLBACK;
    }
    if (trimmed.toLowerCase() === GREETING_FALLBACK.toLowerCase()) {
        return GREETING_FALLBACK;
    }
    const first = trimmed.split(/\s+/)[0];
    return first || GREETING_FALLBACK;
}

/**
 * Preview-only: fill Mustache recipient tags (and legacy greeting placeholders).
 * Java does the same replacement at send time.
 */
export function personalizeGreetingHtml(content, recipientName, unsubscribeUrl) {
    if (!content) return content;
    const display = firstNameOrFallback(recipientName);
    const personalized = `Hi ${display},`;
    let out = content
        .replace(/\{\{\{\s*firstName\s*\}\}\}/g, display)
        .replace(/\{\{\s*firstName\s*\}\}/g, display)
        .replace(/Hi \[First Name \/ Puzzle Lover\],/g, personalized)
        .replace(/Hi there,/g, personalized);
    if (unsubscribeUrl) {
        out = out
            .replace(/\{\{\{\s*unsubscribeUrl\s*\}\}\}/g, unsubscribeUrl)
            .replace(/\{\{\s*unsubscribeUrl\s*\}\}/g, unsubscribeUrl);
    }
    return out;
}

/** Preview + sent HTML: open every link in a new tab so the admin page (and mail clients that honor it) stay put. */
export function forceLinksOpenInNewTab(html) {
    if (!html) return html;
    return String(html).replace(/<a\b([^>]*)>/gi, (full, attrs) => {
        let next = attrs;
        if (!/\btarget\s*=/i.test(next)) {
            next += ' target="_blank"';
        }
        if (!/\brel\s*=/i.test(next)) {
            next += ' rel="noopener noreferrer"';
        }
        return `<a${next}>`;
    });
}
